.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.infoText {
  color: var(--body-text-arrows-400);
  height: 40px;
  align-content: center;
}

gz-title + gz-form-field,
gz-title + gz-labeled-content,
gz-title + div {
  padding-top: 15px;
}

#action-field {
  position: relative;
  z-index: 0;
}

gz-labeled-content {
  &::part(content) {
    overflow: visible;
  }

  &::part(label) {
    --font-family: var(--font-family-secondary);
  }
}

gz-radio-group {
  display: flex;
}

#rule-scope-from-specific-field,
#rule-scope-to-specific-field {
  margin-top: calc(var(--spacer) * -4); // remove extra space
  margin-left: 50px;
}

#rule-scope-from-description,
#rule-scope-to-description {
  margin-top: -30px;
}

gz-checkbox {
  width: auto;
}
